export const generalHelpers = {
  escapeString(string) {
    return string.replace(/([;&,.+*~':"!^#$%@[\]()=>|])/g, '\\$1');
  },
  hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  },
  addClass(ele, cls) {
    if (!this.hasClass(ele, cls)) {
      ele.className += ' ';
      ele.className += cls;
    }
  },
  removeClass(ele, cls) {
    if (this.hasClass(ele, cls)) {
      const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      ele.className = ele.className.replace(reg, ' ').trim();
    }
  },
  toggleClass(element, className) {
    if (this.hasClass(element, className)) {
      this.removeClass(element, className);
    } else {
      this.addClass(element, className);
    }
  },
};
